import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, AbstractControl, FormGroup, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { PermissionFormData } from '../../../../shared/models/permission-form-data';

function permissionIdValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;

	if(!value) {
		return null;
	}

	const regex = /^[a-zA-Z0-9_\-]+(\.[a-zA-Z0-9_\-\*]+)$/;

	if(value === '*.*' || regex.test(value)) {
		return null;
	}

	return {invalidPermissionId: true};
}

@Component({
	selector: 'app-permission-form',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, MatButtonModule, MatIconModule, MatDialogTitle, MatDialogContent],
	templateUrl: './permission-form.html',
	styleUrl: './permission-form.css'
})

export class PermissionForm {
	permissionForm: FormGroup;
  	isEditMode: boolean = false;

	constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<PermissionForm, PermissionFormData | undefined>, @Inject(MAT_DIALOG_DATA) public data: PermissionFormData | null) {
		this.isEditMode = !!data;
		
		this.permissionForm = this.fb.group({
			id          : [{value: data?.id || '', disabled: this.isEditMode}, [Validators.required, permissionIdValidator]],
			name        : [data?.name || '', [Validators.required]],
			description : [data?.description || ''],
			group       : [data?.group || 'General'],
			active      : [data?.active ?? true]
		});
	}

	get idControl() {
		return this.permissionForm.get('id');
	}

	get nameControl() {
		return this.permissionForm.get('name');
	}

	onSubmit(): void {
		this.permissionForm.markAllAsTouched();

		if(this.permissionForm.valid) {
			this.dialogRef.close(this.permissionForm.getRawValue() as PermissionFormData);
		}
	}

	onCancel(): void {
		this.dialogRef.close(undefined);
	}
}